<template>
    <div class="flex">
        <button class="text-[18px] border border-blue-700 text-blue-700 font-bold px-6 py-3 rounded-[15px] montsr hover:bg-blue-700 hover:text-white mx-auto">Загрузить ещё</button>
    </div>
</template>